module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "modul-belajar-from"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/modul-belajar'
      }
    }
  }, [_vm._v("Modul Belajar")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Form")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Buat Tryout Baru")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('title') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Judul *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.errors.indexOf('title') != -1) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("field ini wajib diisi")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Judul / nama modul",
      "required": ""
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('join_code') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Join Code *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.errors.indexOf('join_code') != -1) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("field ini wajib diisi")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.joinCode),
      expression: "joinCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Generate / Ketik kode join sendiri",
      "required": ""
    },
    domProps: {
      "value": (_vm.joinCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.joinCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-inverse",
    on: {
      "click": function($event) {
        _vm.joinCode = _vm.generateRandomCode(6)
      }
    }
  }, [_vm._v("Generate")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Deskripsi")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Deksripsi modul",
      "required": ""
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('picture') != -1
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Picture *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.errors.indexOf('picture') != -1) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("field ini wajib diisi")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('file-upload', {
    attrs: {
      "context": "modul_belajar"
    },
    on: {
      "uploaded": function($event) {
        _vm.picture = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.picture != null) ? _c('img', {
    staticClass: "rounded-corner height-100 width-100",
    attrs: {
      "src": _vm.picture
    }
  }) : _vm._e()])])])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmitBtnClicked()
      }
    }
  }, [_vm._v("Simpan")]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right m-1"
  }, [_c('li', {
    staticClass: "dropdown navbar-user dropleft"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu animated fadeInLeft"
  }, [_c('li', {
    staticClass: "arrow"
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.onManageMaterialBtnClicked()
      }
    }
  }, [_vm._v("Kelola Materi")])]), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.onManageLiveStreamBtnClicked()
      }
    }
  }, [_vm._v("Live Streaming")])])])])])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Buat Modul Belajar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-inverse",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n                  Kelola\n                  "), _c('span', {
    staticClass: "hidden-xs"
  }), _vm._v(" "), _c('b', {
    staticClass: "caret"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-298e60a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modul_pembelajaran/Form.vue
// module id = 1310
// module chunks = 0